import { SideMenuTopic } from '@/const/SideMenuTopic'

/**
 * 塾管理者用サイドメニューに表示する項目の定義
 */
export namespace AcademySideMenuTopic {
  /** 生徒一覧 */
  const STUDENT_LIST: Topic = {
    text: '生徒管理',
    icon: '/img/icon/manage/sidemenu/student_list.svg',
    url: '/academy/students',
  }

  /** 生徒進捗確認 */
  const STUDENT_PROGRESS: Topic = {
    text: '生徒進捗確認',
    icon: '/img/icon/manage/sidemenu/student_list.svg',
    url: '/academy/students/progress/general',
    subUrls: ['/academy/students/progress/map', '/academy/students/.*/progress', '/academy/students/.*/map'],
  }

  /** 教室一覧 */
  const BRANCH_LIST: Topic = {
    text: '教室管理',
    icon: '/img/icon/manage/sidemenu/branch_list.svg',
    url: '/academy/branches',
  }

  /** ユーザ管理 */
  const TEACHER_LIST: Topic = {
    text: 'ユーザ管理',
    icon: '/img/icon/manage/sidemenu/teacher_list.svg',
    url: '/academy/teachers',
  }

  /** お知らせ */
  const NOTICE: Topic = {
    text: 'お知らせ',
    icon: '/img/icon/manage/sidemenu/notice.svg',
    url: '/academy/notice',
    subUrls: ['/academy/notice/.*'],
  }

  /** 通常学習進捗比較 */
  const COMPARE_LEARNING_PROGRESS: Topic = {
    text: '通常学習進捗比較',
    icon: '/img/icon/manage/sidemenu/compare_general_learning_progress.svg',
    url: '/academy/progress/branch',
    subUrls: ['/academy/progress/course', '/academy/progress/class'],
  }

  /** 校正ツール */
  const PROOFREAD: Topic = {
    text: '校正ツール',
    icon: '/img/icon/manage/sidemenu/compare_general_learning_progress.svg',
    url: '/academy/proofread',
    subUrls: ['/academy/proofread/.*'],
  }

  /** 校正ツール(知識マップ) */
  const PROOFREAD_MAP: Topic = {
    text: '知識マップ校正',
    icon: '/img/icon/manage/sidemenu/compare_general_learning_progress.svg',
    url: '/academy/map',
    subUrls: ['/academy/map/.*'],
  }

  /** マニュアル */
  const MANUAL: Topic = {
    text: 'マニュアル',
    icon: '/img/icon/student/sidemenu/map.svg',
    url: '/academy/manual',
    target: '_blank',
  }

  /** メニュー項目一覧 */
  export const LIST: Topic[] = [
    STUDENT_LIST,
    STUDENT_PROGRESS,
    BRANCH_LIST,
    TEACHER_LIST,
    NOTICE,
    COMPARE_LEARNING_PROGRESS,
    PROOFREAD,
    PROOFREAD_MAP,
    MANUAL,
  ]

  /** メニュー項目の型 */
  export type Topic = SideMenuTopic.Topic
}
